module.exports = __webpack_public_path__ + "img/img_2.763fe9af.png";